import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import InputsSection from '../../components/Modal/InputsSection';
import InputsSectionColumn from '../../components/Modal/InputsSectionColumn';
import InputBox from '../../components/Modal/InputBox';
import ModalButtons from '../../components/Modal/ModalButtons';
import ShareFileSkeleton from '../../components/Skeletons/ShareFileSkeleton';
import { inputPhoneMasking, unMasking, validateEmail, validatePhone } from '../../utils/validators';

const ShareFileForESignModal = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { shareFileForESignModal, setShareFileForESignModal, shareFileForESignInputs, setShareFileForESignInputs, handleShareFileForESign } = data;

  const shareFile = useSelector(state => state.shareFile);

  const onModalClose = () => {
    setShareFileForESignModal({ file: {}, status: false });
    setShareFileForESignInputs({ email: { value: '', error: '' }, fullName: { value: '', error: '' }, phone: { value: '', error: '' } });
  };

  const handleShareFile = () => {
    if (!validateEmail(shareFileForESignInputs.email.value)) {
      setShareFileForESignInputs(prevVal => ({ ...prevVal, email: { ...prevVal.email, error: t('screens.fileExchange.errValidEmail') } }));
    } else if (shareFileForESignInputs.createAccount && !shareFileForESignInputs.fullName.value) {
      setShareFileForESignInputs(prevVal => ({ ...prevVal, fullName: { ...prevVal.fullName, error: t('screens.fileExchange.errEnterFullName') } }));
    } else if (shareFileForESignInputs.createAccount && !validatePhone(unMasking(shareFileForESignInputs.phone.value))) {
      setShareFileForESignInputs(prevVal => ({ ...prevVal, phone: { ...prevVal.phone, error: t('screens.fileExchange.errEnterPhone') } }));
    } else {
      handleShareFileForESign();
    }
  };

  return (
    <Modal show={shareFileForESignModal.status}>
      {shareFile && shareFile.loading ? (
        <ShareFileSkeleton fileProtected={shareFileForESignModal.file.protected} />
      ) : (
        <React.Fragment>
          <ModalHeading heading={t('screens.fileExchange.shareESignTitle', { name: shareFileForESignModal.file.name })} />
          <ModalForm style={{ marginBottom: '2.5rem' }}>
            <InputsSectionColumn style={{ width: '34rem' }}>
              <InputBox
                label={t('screens.fileExchange.enterEmailToShare')}
                type='text'
                placeholder={t('screens.fileExchange.emailPh')}
                value={shareFileForESignInputs.email.value}
                onChange={event => {
                  setShareFileForESignInputs(prevVal => ({ ...prevVal, email: { value: event.target.value, error: '' } }));
                }}
                errorMessage={shareFileForESignInputs.email.error}
                style={{ width: '30rem' }}
              />
              <div className='flex'>
                <label htmlFor='create-user'>{t('screens.fileExchange.createAccountLabel')}</label>
                <label className='switch'>
                  <input
                    id='create-user'
                    checked={shareFileForESignInputs.createAccount}
                    onChange={e => {
                      setShareFileForESignInputs(prevVal => ({
                        ...prevVal,
                        createAccount: !prevVal.createAccount,
                        fullName: { value: '', error: '' },
                        phone: { value: '', error: '' },
                      }));
                    }}
                    type='checkbox'
                    className='checkbox'
                    name='create'
                  />
                  <span className='slider round' />
                </label>
              </div>
            </InputsSectionColumn>
            {shareFileForESignInputs.createAccount && (
              <InputsSectionColumn style={{ width: '34rem' }}>
                <InputBox
                  label={t('screens.fileExchange.fullName')}
                  type='text'
                  placeholder={t('screens.fileExchange.fullNamePh')}
                  value={shareFileForESignInputs.fullName.value}
                  onChange={event => {
                    setShareFileForESignInputs(prevVal => ({ ...prevVal, fullName: { value: event.target.value, error: '' } }));
                  }}
                  errorMessage={shareFileForESignInputs.fullName.error}
                  style={{ width: '30rem' }}
                />
                <InputBox
                  label={t('screens.fileExchange.phone')}
                  type='text'
                  placeholder={t('screens.fileExchange.phonePh')}
                  value={shareFileForESignInputs.phone.value}
                  onChange={event => {
                    setShareFileForESignInputs(prevVal => ({ ...prevVal, phone: { value: inputPhoneMasking(event.target.value), error: '' } }));
                  }}
                  errorMessage={shareFileForESignInputs.phone.error}
                  style={{ width: '30rem' }}
                />
              </InputsSectionColumn>
            )}

            <ModalButtons submitButtonLabel={t('screens.fileExchange.shareForESignBtn')} onSubmit={handleShareFile} cancelButtonLabel={t('screens.fileExchange.cancel')} onCancel={onModalClose} />
          </ModalForm>
        </React.Fragment>
      )}
    </Modal>
  );
};

export default ShareFileForESignModal;
